import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import { modalsActions } from '../../modalsSlice';
import './confirmation.scss';

interface IConfirmationProps {
  message: string;
  cancelBtnText: string;
  confirmBtnText: string;
  redirectPath: string;
}
function Confirmation({
  message,
  cancelBtnText,
  confirmBtnText,
  redirectPath,
}: IConfirmationProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(modalsActions.confirmation(false));
  };

  const handleConfirm = () => {
    closeModal();
    navigate(`/${redirectPath}`);
  };

  return (
    <div className="confirmation-overlay">
      <div className="confirmation">
        <h3 className="confirmation-title">{message}</h3>

        <div className="confirmation-btns">
          <Button
            btnType="button"
            btnContent={cancelBtnText}
            handleClick={closeModal}
            primary
          />
          <Button
            btnType="button"
            btnContent={confirmBtnText}
            handleClick={handleConfirm}
            textColor="violet"
            bgColor="white"
            borderColor="grey"
          />
        </div>
      </div>
    </div>
  );
}

Confirmation.propTypes = {
  message: PropTypes.string.isRequired,
  cancelBtnText: PropTypes.string.isRequired,
  confirmBtnText: PropTypes.string.isRequired,
  redirectPath: PropTypes.string.isRequired,
};

export default Confirmation;
